import api from "../config/api/axiosConfig";
import { useCallback } from "react";
import { useFontenehus } from "../context/FontenehusContext";

export interface CreateSuggestionDTO {
  recipeId: number;
  date?: string | undefined;
  fontenehusId?: number;
  anonymous: boolean;
}

export const useSuggestionApi = () => {
  const { selectedFontenehus } = useFontenehus();

  // 🟢 Get all suggestions for a given date
  const getSuggestionByDate = useCallback(
    async (date: string | undefined) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");
      const response = await api.get(`/Suggestion`, {
        params: { date, fontenehusId: selectedFontenehus.id },
      });

      response.data.data = response.data.data.map((s: any) => ({
        ...s,
        date: s.date && s.date.startsWith("1000-01-01") ? null : s.date,
      }));

      response.data.data = response.data.data.map((s: any) => ({
        ...s,
        suggestedById:
          s.suggestedById && s.suggestedById === 0 ? null : s.suggestedById,
      }));

      return response; // ✅ Now res.data is cleaned
    },
    [selectedFontenehus],
  );

  // 🟠 Create a new suggestion
  const createSuggestion = useCallback(
    async (dto: CreateSuggestionDTO) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");

      const payload = {
        ...dto,
      };

      const response = await api.post(`/Suggestion`, payload);
      return response;
    },
    [selectedFontenehus],
  );

  // 🔴 Delete a suggestion by its ID
  const deleteSuggestion = useCallback(
    async (suggestionId: number) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");

      const response = await api.delete(`/Suggestion/${suggestionId}`, {
        params: { fontenehusId: selectedFontenehus.id },
      });
      return response;
    },
    [selectedFontenehus],
  );

  // 💖 Toggle like for a suggestion
  const toggleLike = useCallback(
    async (suggestionId: number) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");

      const response = await api.post(
        `/Suggestion/toggle-like`,
        {},
        {
          params: { suggestionId },
        },
      );

      // Returns { suggestionId, likeCount, isLikedByCurrentUser }
      return response;
    },
    [selectedFontenehus],
  );

  return {
    getSuggestionByDate,
    createSuggestion,
    deleteSuggestion,
    toggleLike,
  };
};
